import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavItemT, AppNavBar } from 'baseui/app-nav-bar';
import { session } from '../../shared/session';
import { modules } from '../../config/routing';
import { getFakerSwitch, setFakerSwitch } from '../../config/endpoints/api';
import { Paragraph2 } from 'baseui/typography';
import { useMediaQuery } from '../../shared/hooks/useMediaQuery';
import { useStyletron } from 'baseui';
import { useMemo } from 'react';
import { MenuItem, MenuProps } from '../Menu/Menu';
import { isAuthorized } from '../../shared/auth';
import { ThemeSwitcher } from '../../shared/themes/ThemeSwitcher';

interface NavBarProps extends MenuProps {
}
interface NavItem extends NavItemT {
    path?: string
}
function renderItem(item: NavItem, isDesktop: boolean) {
    if (item.info.id === 'haper_faker') {
        return (
            <Paragraph2>
                {item.label}
                <br/>
                <small>{'Obency: '} {getFakerSwitch() ? 'lokalny' : window.appConfig.API_URL}</small>
            </Paragraph2>
        )
    }
    if (item.info.id === 'logout') return item.label
    if(isDesktop) return null;
    return item.label
}

const appVersion = process.env.APP_VERSION;

export const NavBar = ({ routes }: NavBarProps) => {
    const { t } = useTranslation();
    const { push } = useHistory();
    const [, theme] = useStyletron();
    const shouldShowDesktopMenu = useMediaQuery(theme.mediaQuery.large.replace('@media ',''));
    const { pathname } = useLocation();

    const mapMenuItemsToNavigationItems = (menuItems: Array<MenuItem>, parentPath?: string, pathname?: string):Array<NavItem> => {
        return menuItems
            .filter(
                (route) =>
                    isAuthorized(route.authorizedRoles) && !route.hideInMenu,
            )
            .map((route) => ({
                info: { 
                    id: `#${parentPath || ''}${route.path}`
                },
                active: pathname === route.path,
                path: `${parentPath || ''}${route.path}`,
                label: t(route.title),
                children: route.children ? mapMenuItemsToNavigationItems(route.children, route.path) : []
            }));
    }
    
    const navigationItems: Array<NavItem> = useMemo(() => {
        return mapMenuItemsToNavigationItems(routes, undefined, pathname)
   }, [routes, pathname]);

    const userNav = [ {
            label: t('Logout'),
            info: {
                id: 'logout'
            }
        },
    ];

    if (process.env.NODE_ENV === 'development') {
        userNav.push({
            label: t('Przełącz backend'),
            info: {
                id: 'haper_faker'
            }
        })
    }
    const handleItemSelect = (item: any) => {
        !item.children.length && push(item.path);
    }
    return (
        <header>
            <AppNavBar
                title={
                    <div style={{ position: 'relative' }}>
                        <span style={{ position: 'relative' }}>
                            {t('appName')}
                            <small
                                style={{
                                    fontSize: '0.4em',
                                    marginTop: -4,
                                    position: 'absolute',
                                    left: 0,
                                    bottom: -22,
                                }}
                            >
                                v{appVersion}
                            </small>
                        </span>
                        <ThemeSwitcher style={{position: 'absolute', right: '-12rem', top: '0'}} />
                    </div>
                }
                mainItems={navigationItems}
                onMainItemSelect={handleItemSelect}
                mapItemToNode={(e) => renderItem(e, shouldShowDesktopMenu)}
                onUserItemSelect={(item) => {
                    if (item.info.id === 'logout') {
                        session.destroy();

                        push(modules.Login.path);
                    }

                    if (item.info.id === 'haper_faker') {
                        setFakerSwitch(!getFakerSwitch());
                        window.location.reload();
                    }
                }}
                userItems={userNav}
                username={session.data?.userName}
                usernameSubtitle={session.data?.email}
                overrides={
                    {
                        UserMenu: {
                            //badziew nie działa
                            style: {
                                width: "400px"
                            }
                        }
                    }
                }
            />
        </header>
    );
};
